import styled from "@emotion/styled";

export const TopBox = styled('div')(() => ({
    height: "max-content",
    minWidth: `${144 - 6 - 6}pt`,
    width: `${144 - 6 - 6}pt`,
    boxSizing: 'border-box',

    margin: '0',
    padding: '0',

    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    alignContent: 'flex-start',

    alignSelf: 'center'
    // border: '1pt solid red'

}))